export default {
  name: 'gmk-mizu',
  override: {
    KC_ESC: 'accent',
    KC_ENT: 'accent',
    KC_PENT: 'accent'
  }
};
